module.exports = __webpack_public_path__ + "static/media/38.87aa674f.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/shirts/38.png
// module id = 999
// module chunks = 0